import React, { createContext, useContext, useMemo, useState } from 'react';

export type PaymentLinkNoticeContextValue = {
    visible: boolean;
    setVisible: (visible: boolean) => void;
};

const PaymentLinkNoticeContext = createContext<PaymentLinkNoticeContextValue | null>(null);

type ProviderProps = {
    children: React.ReactNode;
    /** Initial visibility; default false until eligibility rules are wired (e.g. via setVisible). */
    initialVisible?: boolean;
};

export const PaymentLinkNoticeProvider = ({ children, initialVisible = false }: ProviderProps) => {
    const [visible, setVisible] = useState(initialVisible);
    const value = useMemo(() => ({ visible, setVisible }), [visible]);
    return (
        <PaymentLinkNoticeContext.Provider value={value}>
            {children}
        </PaymentLinkNoticeContext.Provider>
    );
};

export function usePaymentLinkNotice(): PaymentLinkNoticeContextValue {
    const ctx = useContext(PaymentLinkNoticeContext);
    if (!ctx) {
        throw new Error('usePaymentLinkNotice must be used within PaymentLinkNoticeProvider');
    }
    return ctx;
}
